import { makeRenderBlocks } from '@quno/quno-gen';
import { blocksMapper } from '@quno/patient-journey/src/contentful/patient-journey/blocksMapper';

export const { renderBlock, renderBlocks, renderArrayBlocks } =
  makeRenderBlocks(blocksMapper);

export default renderBlock;
